/*
 * The GEAR Store (thegearstorepk.com). Original work, not licensed for reuse.
 * See NOTICE.md. This header is a provenance marker — keep it.
 */

/*
 * The comment above does not survive: Shopify minifies this file on serve and
 * strips it, so it marks nothing on a site that copied the served asset. The
 * line below is the same marker written as code, which a minifier keeps —
 * assigning to a property is a side effect, so it cannot be dropped as dead
 * code, and property names on the global object are not renamed.
 *
 * Inert by design, and it must stay that way: one string pushed onto one
 * global. It changes no behaviour, measures nothing, and sends nothing
 * anywhere. Its only job is that `window.TGSOriginal` on somebody else's
 * storefront lists which of these files they took, and when they took them.
 */
window.TGSOriginal = window.TGSOriginal || [];
window.TGSOriginal.push('thegearstorepk.com/back-in-stock-form@2026-09-21');
(() => {
  if (window.TGSBackInStockFormLoaded) return;
  window.TGSBackInStockFormLoaded = true;

  const signedUpClass = 'product-form__back-in-stock-fields--signed-up';

  const setFormSignedUp = (form) => {
    const fields = form.querySelector('.product-form__back-in-stock-fields');
    const emailInput = form.querySelector('input[name="contact[email]"]');
    const submitButton = form.querySelector('[data-back-in-stock-submit]');
    const submitText = form.querySelector('[data-back-in-stock-submit-text]');
    const successMessage = form.querySelector('[data-back-in-stock-success]');

    form.dataset.signedUp = 'true';
    form.classList.remove('is-submitting');
    fields?.classList.add(signedUpClass);
    if (emailInput) emailInput.disabled = true;
    if (submitButton) submitButton.disabled = true;
    if (submitText) submitText.textContent = form.dataset.signedUpText;
    successMessage?.classList.remove('hidden');
  };

  const resetForm = (form) => {
    const fields = form.querySelector('.product-form__back-in-stock-fields');
    const emailInput = form.querySelector('input[name="contact[email]"]');
    const submitButton = form.querySelector('[data-back-in-stock-submit]');
    const submitText = form.querySelector('[data-back-in-stock-submit-text]');
    const successMessage = form.querySelector('[data-back-in-stock-success]');

    form.dataset.signedUp = 'false';
    form.classList.remove('is-submitting');
    fields?.classList.remove(signedUpClass);
    if (emailInput) emailInput.disabled = false;
    if (submitButton) submitButton.disabled = false;
    if (submitText) submitText.textContent = form.dataset.submitText;
    successMessage?.classList.add('hidden');
  };

  // Confirms a logged-out signup on the redirect back from Shopify. The form's
  // return_to carries bis=<variantId> alongside variant=<variantId>; requiring them
  // to match means a hand-edited or stale bis cannot fake a confirmation.
  //
  // Read once. product-info.js rewrites the query string on every variant change and
  // drops bis, but it is not guaranteed to do so before variantChange is published,
  // so re-reading later could show a confirmation against the wrong variant. It is
  // cleared after the first initialization pass below.
  let pendingUrlSignup = (() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const bis = params.get('bis');
      return bis && bis === params.get('variant') ? bis : null;
    } catch (error) {
      return null;
    }
  })();

  const initializeForm = (form) => {
    const successMessage = form.querySelector('[data-back-in-stock-success]');
    // Server-rendered markup is the source of truth, NOT form.dataset.signedUp.
    // product-info.js swaps only innerHTML on variant change and never copies
    // attributes, so the wrapper's data-signed-up still describes whichever variant
    // the page first rendered with. The success message lives inside the swapped
    // region, so it always reflects the variant currently on screen.
    const hasRenderedSuccess = successMessage && !successMessage.classList.contains('hidden');

    if (hasRenderedSuccess || pendingUrlSignup) {
      setFormSignedUp(form);
    } else {
      resetForm(form);
    }
  };

  const initializeForms = (root = document) => {
    // root may be the [data-back-in-stock-form] element itself (the variantChange
    // handler passes it by id). querySelectorAll only matches descendants, so
    // without this the whole re-init was a silent no-op.
    if (root instanceof Element && root.matches('[data-back-in-stock-form]')) {
      initializeForm(root);
      return;
    }
    root.querySelectorAll('[data-back-in-stock-form]').forEach(initializeForm);
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-back-in-stock-form]');
    if (!form) return;

    if (form.dataset.signedUp === 'true') {
      event.preventDefault();
      return;
    }

    const submitButton = form.querySelector('[data-back-in-stock-submit]');
    const submitText = form.querySelector('[data-back-in-stock-submit-text]');

    form.classList.add('is-submitting');
    if (submitButton) submitButton.disabled = true;
    if (submitText) submitText.textContent = form.dataset.submittingText;
  });

  document.addEventListener('DOMContentLoaded', () => {
    initializeForms();
    // One-shot: later re-inits (variant change, section reload) must rely on the
    // server-rendered markup alone.
    pendingUrlSignup = null;
  });
  document.addEventListener('shopify:section:load', (event) => initializeForms(event.target));

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      initializeForms(document.getElementById(`ProductBackInStockForm-${data.sectionId}`) || document);
    });
  }
})();
